class CountdownTimer {
  constructor(sectionId) {
    this.section = document.getElementById(sectionId);
    if (!this.section) return;

    this.daysElement = this.section.querySelector('#days');
    this.hoursElement = this.section.querySelector('#hours');
    this.minutesElement = this.section.querySelector('#minutes');
    this.secondsElement = this.section.querySelector('#seconds');
    
    this.init();
  }

  init() {
    const endDate = this.section.dataset.endDate;
    if (!endDate) return;

    this.endDate = new Date(endDate).getTime();
    this.updateCountdown();
    setInterval(() => this.updateCountdown(), 1000);
  }

  updateCountdown() {
    const now = new Date().getTime();
    const distance = this.endDate - now;
    
    if (distance < 0) {
      this.setTimerValues('00', '00', '00', '00');
      return;
    }
    
    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);
    
    this.setTimerValues(
      days.toString().padStart(2, '0'),
      hours.toString().padStart(2, '0'),
      minutes.toString().padStart(2, '0'),
      seconds.toString().padStart(2, '0')
    );
  }

  setTimerValues(days, hours, minutes, seconds) {
    this.daysElement.textContent = days;
    this.hoursElement.textContent = hours;
    this.minutesElement.textContent = minutes;
    this.secondsElement.textContent = seconds;
  }
}

// Initialize all countdown timers on the page
document.addEventListener('DOMContentLoaded', () => {
  const countdownTimers = document.querySelectorAll('[id^="countdown-timer-"]');
  countdownTimers.forEach(timer => {
    new CountdownTimer(timer.id);
  });
}); 